{
  "AUTOMATION": {
    "HEADER": "خودکارسازی",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "COUNT": "{n} automation | {n} automations",
    "HEADER_BTN_TXT": "Create Automation",
    "LOADING": "واکشی قوانین اتوماسیون",
    "SEARCH_PLACEHOLDER": "Search automation rules...",
    "NO_RESULTS": "No automation rules found matching your search",
    "ADD": {
      "TITLE": "افزودن قانون خودکارسازی",
      "SUBMIT": "ايجاد كردن",
      "CANCEL_BUTTON_TEXT": "انصراف",
      "FORM": {
        "NAME": {
          "LABEL": "نام قانون",
          "PLACEHOLDER": "نام قانون را وارد کنید",
          "ERROR": "نام الزامی است"
        },
        "DESC": {
          "LABEL": "توضیحات",
          "PLACEHOLDER": "توضیحات قانون را وارد کنید",
          "ERROR": "توضیحات الزامی است"
        },
        "EVENT": {
          "LABEL": "رویداد",
          "PLACEHOLDER": "لطفا یکی را انتخاب کنید",
          "ERROR": "رویداد مورد نیاز است"
        },
        "CONDITIONS": {
          "LABEL": "شرایط"
        },
        "ACTIONS": {
          "LABEL": "عملیات"
        }
      },
      "CONDITION_BUTTON_LABEL": "اضافه کردن شرط",
      "ACTION_BUTTON_LABEL": "افزودن اکشن",
      "API": {
        "SUCCESS_MESSAGE": "قانون اتوماسیون با موفقیت اضافه شد",
        "ERROR_MESSAGE": "نمی‌توان یک قانون اتوماسیون ایجاد کرد، لطفاً بعداً دوباره امتحان کنید"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "نام",
        "ACTIVE": "فعال",
        "CREATED_ON": "ایجاد شده در",
        "ACTIONS": "عملیات"
      },
      "404": "هیچ قانون اتوماسیون یافت نشد"
    },
    "DELETE": {
      "TITLE": "قانون اتوماسیون را حذف کنید",
      "SUBMIT": "حذف",
      "CANCEL_BUTTON_TEXT": "انصراف",
      "CONFIRM": {
        "TITLE": "تاییدیه حذف",
        "MESSAGE": "مطمئن هستید که حذف شود ",
        "YES": "بله، حذف شود ",
        "NO": "نه، بماند "
      },
      "API": {
        "SUCCESS_MESSAGE": "قانون اتوماسیون با موفقیت حذف شد",
        "ERROR_MESSAGE": "نمی‌توان یک قانون اتوماسیون را حذف کرد، لطفاً بعداً دوباره امتحان کنید"
      }
    },
    "EDIT": {
      "TITLE": "ویرایش قانون اتوماسیون",
      "SUBMIT": "اعمال شود",
      "CANCEL_BUTTON_TEXT": "انصراف",
      "API": {
        "SUCCESS_MESSAGE": "قانون اتوماسیون با موفقیت به روز شد",
        "ERROR_MESSAGE": "قانون اتوماسیون به‌روزرسانی نشد، لطفاً بعداً دوباره امتحان کنید"
      }
    },
    "CLONE": {
      "TOOLTIP": "کلون",
      "API": {
        "SUCCESS_MESSAGE": "اتوماسیون با موفقیت کلون شد",
        "ERROR_MESSAGE": "نمی‌توان قانون اتوماسیون را کلون کرد، لطفاً بعداً دوباره امتحان کنید"
      }
    },
    "FORM": {
      "EDIT": "ویرایش",
      "CREATE": "ايجاد كردن",
      "DELETE": "حذف",
      "CANCEL": "انصراف",
      "RESET_MESSAGE": "با تغییر نوع رویداد، شرایط و رویدادهایی که در زیر اضافه کرده‌اید بازنشانی می‌شود"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "شما باید حداقل یک شرط برای ذخیره داشته باشید",
      "CONTACT_CUSTOM_ATTR_LABEL": "ویژگی‌های سفارشی تماس",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "ویژگی‌های سفارشی گفتگو"
    },
    "ACTION": {
      "DELETE_MESSAGE": "برای ذخیره باید حداقل یک اکشن داشته باشید",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "پیام خود را اینجا وارد کنید",
      "TEAM_DROPDOWN_PLACEHOLDER": "انتخاب تیم‌ها",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "فعال کردن قانون اتوماسیون",
      "DEACTIVATION_TITLE": "غیرفعال کردن قانون اتوماسیون",
      "ACTIVATION_DESCRIPTION": "این اقدام قانون اتوماسیون «{automationName}» را فعال خواهد کرد. مطمئنی که می‌خوای ادامه بدی؟",
      "DEACTIVATION_DESCRIPTION": "این اقدام قانون اتوماسیون «{automationName}» را غیرفعال خواهد کرد. مطمئنی که می‌خوای ادامه بدی؟",
      "ACTIVATION_SUCCESFUL": "قانون اتوماسیون با موفقیت فعال شد",
      "DEACTIVATION_SUCCESFUL": "قانون اتوماسیون با موفقیت غیرفعال شد",
      "ACTIVATION_ERROR": "اتوماسیون نمی‌توان فعال شد، لطفا بعدا دوباره امتحان کنید",
      "DEACTIVATION_ERROR": "اتوماسیون نمی‌توان غیرفعال شد، لطفا بعدا دوباره امتحان کنید",
      "CONFIRMATION_LABEL": "بله",
      "CANCEL_LABEL": "خیر"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "پیوست آپلود نشد، لطفا دوباره امتحان کنید",
      "LABEL_IDLE": "بارگذاری پیوست",
      "LABEL_UPLOADING": "در حال بارگذاری...",
      "LABEL_UPLOADED": "با موفقیت آپلود شد",
      "LABEL_UPLOAD_FAILED": "بارگذاری انجام نشد"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "مقدار الزامی است",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "NONE_OPTION": "هیچکدام",
    "LAST_RESPONDING_AGENT": "Last Responding Agent",
    "EVENTS": {
      "CONVERSATION_CREATED": "گفتگو ایجاد شد",
      "CONVERSATION_UPDATED": "گفتگو به روز شد",
      "MESSAGE_CREATED": "Message Created",
      "CONVERSATION_RESOLVED": "Conversation Resolved",
      "CONVERSATION_OPENED": "Conversation Opened"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Assign to Agent",
      "ASSIGN_TEAM": "Assign a Team",
      "REMOVE_ASSIGNED_AGENT": "Remove Assigned Agent",
      "REMOVE_ASSIGNED_TEAM": "Remove Assigned Team",
      "ADD_LABEL": "Add a Label",
      "REMOVE_LABEL": "Remove a Label",
      "SEND_EMAIL_TO_TEAM": "Send an Email to Team",
      "SEND_EMAIL_TRANSCRIPT": "Send an Email Transcript",
      "MUTE_CONVERSATION": "بی‌صدا کردن گفتگو",
      "SNOOZE_CONVERSATION": "به تعویق انداختن مکالمه",
      "RESOLVE_CONVERSATION": "حل مکالمه",
      "SEND_WEBHOOK_EVENT": "Send Webhook Event",
      "SEND_ATTACHMENT": "Send Attachment",
      "SEND_MESSAGE": "Send a Message",
      "ADD_PRIVATE_NOTE": "Add a Private Note",
      "CHANGE_PRIORITY": "تغییر اولویت",
      "ADD_SLA": "اضافه کردن SLA",
      "OPEN_CONVERSATION": "باز کردن گفتگو",
      "PENDING_CONVERSATION": "Mark conversation as pending"
    },
    "MESSAGE_TYPES": {
      "INCOMING": "Incoming Message",
      "OUTGOING": "Outgoing Message"
    },
    "PRIORITY_TYPES": {
      "NONE": "هیچکدام",
      "LOW": "پایین",
      "MEDIUM": "متوسط",
      "HIGH": "بالا",
      "URGENT": "فوری"
    },
    "ATTRIBUTES": {
      "MESSAGE_TYPE": "Message Type",
      "PRIVATE_NOTE": "یادداشت خصوصی",
      "MESSAGE_CONTAINS": "Message Contains",
      "EMAIL": "ایمیل",
      "INBOX": "صندوق ورودی",
      "CONVERSATION_LANGUAGE": "Conversation Language",
      "PHONE_NUMBER": "شماره تلفن",
      "STATUS": "وضعیت",
      "BROWSER_LANGUAGE": "مرور زبان",
      "MAIL_SUBJECT": "Email Subject",
      "COUNTRY_NAME": "کشور",
      "COMPANY_NAME": "شرکت",
      "REFERER_LINK": "Referrer Link",
      "ASSIGNEE_NAME": "مسئول",
      "TEAM_NAME": "تیم‌",
      "PRIORITY": "اولویت",
      "LABELS": "برچسب‌ها"
    }
  }
}
